import Swiper from 'swiper'
import { Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'

export class FadeSlider {
  constructor() {
    const slider = document.querySelector('.js-fade_slider')
    if (!slider) return

    const swiper = new Swiper('.js-fade_slider', {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 2000,
    })
  }
}
